angular.module('gym.contacts').controller('ExportContactsCtrl', ["$scope", "$modalInstance", "$http", "flash", "url", "params", function($scope, $modalInstance, $http, flash, url, params) {
  var email;
  email = window.currentUser.email;
  $scope.params = angular.extend({}, params, {
    email: email,
    column_schema: 'full'
  });
  $scope.cancel = function() {
    return $modalInstance.dismiss('cancel');
  };
  return $scope.submit = function() {
    $scope.isLoading = true;
    return $http.post(url, $scope.params).then(function() {
      $modalInstance.close();
      return flash.success = "Export queued for delivery";
    }, function(response) {
      $scope.isLoading = false;
      return flash.error = "Request could not be completed. Please try again";
    });
  };
}]);
